if (!customElements.get('mz-store-locator')) {
  class MzStoreLocator extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.signal = this.controller.signal;

      this.searchForm = this.querySelector('[data-location-search-form]');
      this.searchInput = this.querySelector('[data-location-search]');
      this.clearButton = this.querySelector('[data-location-clear]');
      this.resetButton = this.querySelector('[data-location-reset]');
      this.countNode = this.querySelector('[data-location-count]');
      this.emptyNode = this.querySelector('[data-location-empty]');
      this.cards = [...this.querySelectorAll('[data-location-card]')];
      this.markers = [...this.querySelectorAll('[data-location-marker]')];
      this.selectors = [...this.querySelectorAll('[data-location-select]')];

      this.countOne = this.dataset.countOne || '1 Standort';
      this.countMany = this.dataset.countMany || '[count] Standorte';

      this.searchForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.applyFilter(true);
      }, { signal: this.signal });

      this.searchInput?.addEventListener('input', () => this.applyFilter(false), { signal: this.signal });

      this.clearButton?.addEventListener('click', () => {
        this.resetSearch();
        this.searchInput?.focus();
      }, { signal: this.signal });

      this.resetButton?.addEventListener('click', () => {
        this.resetSearch();
        this.searchInput?.focus();
      }, { signal: this.signal });

      this.markers.forEach((marker) => {
        marker.addEventListener('click', () => this.setActive(marker.dataset.locationMarker, true), { signal: this.signal });
      });

      this.selectors.forEach((selector) => {
        selector.addEventListener('click', () => this.setActive(selector.dataset.locationSelect, false), { signal: this.signal });
      });

      this.applyFilter(false);

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect, { signal: this.signal });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    handleBlockSelect = (event) => {
      if (!this.contains(event.target)) return;
      const marker = event.target.matches?.('[data-location-marker]')
        ? event.target
        : this.querySelector(`[data-location-marker="${CSS.escape(event.detail.blockId)}"]`);
      if (marker) this.setActive(marker.dataset.locationMarker, true);
    };

    normalize(value = '') {
      return String(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase('de-CH')
        .replace(/ß/g, 'ss')
        .trim();
    }

    applyFilter(focusFirst) {
      const query = this.normalize(this.searchInput?.value);
      let visibleCount = 0;
      let firstVisibleId = null;

      this.cards.forEach((card) => {
        const matches = !query || this.normalize(card.dataset.locationSearchValue).includes(query);
        card.hidden = !matches;
        const marker = this.markers.find((item) => item.dataset.locationMarker === card.dataset.locationCard);
        if (marker) marker.hidden = !matches;
        if (matches) {
          visibleCount += 1;
          firstVisibleId ||= card.dataset.locationCard;
        }
      });

      if (this.clearButton) this.clearButton.hidden = !query;
      if (this.emptyNode) this.emptyNode.hidden = visibleCount !== 0;
      this.updateCount(visibleCount);

      const currentActive = this.cards.find((card) => card.classList.contains('is-active'));
      if (firstVisibleId && (!currentActive || currentActive.hidden)) {
        this.setActive(firstVisibleId, false);
      }

      if (focusFirst && firstVisibleId) {
        this.querySelector(`[data-location-select="${CSS.escape(firstVisibleId)}"]`)?.focus();
      }
    }

    resetSearch() {
      if (this.searchInput) this.searchInput.value = '';
      this.applyFilter(false);
    }

    updateCount(count) {
      if (!this.countNode) return;
      this.countNode.textContent = count === 1
        ? this.countOne
        : this.countMany.replace('[count]', count);
    }

    setActive(id, scrollCard) {
      if (!id) return;

      this.cards.forEach((card) => {
        const active = card.dataset.locationCard === id;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-current', active ? 'true' : 'false');
      });

      this.markers.forEach((marker) => {
        const active = marker.dataset.locationMarker === id;
        marker.classList.toggle('is-active', active);
        marker.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (scrollCard) {
        this.querySelector(`[data-location-card="${CSS.escape(id)}"]`)?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }

  customElements.define('mz-store-locator', MzStoreLocator);
}
